<template>
  <path fill="currentColor" d="M12 24a12 12 0 1 1 9-4.2l2.7 2.7a.9.9 0 0 1-.6 1.4Zm5.1-16.2H6.8a.9.9 0 0 0 0 1.7h10.3a.9.9 0 0 0 0-1.7Zm0 3.4H6.8a.9.9 0 0 0 0 1.7h10.3a.9.9 0 0 0 0-1.7Zm.9 4.3a.9.9 0 0 0-.9-1H6.8a.9.9 0 0 0 0 1.8h10.3a.9.9 0 0 0 .9-.9Z" />
</template>
